import { render } from "./BasicOptionSettings.vue?vue&type=template&id=169200bf&scoped=true"
import script from "./BasicOptionSettings.vue?vue&type=script&lang=js"
export * from "./BasicOptionSettings.vue?vue&type=script&lang=js"

import "./BasicOptionSettings.vue?vue&type=style&index=0&id=169200bf&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169200bf"]])

export default __exports__